module.exports = __webpack_public_path__ + "static/media/cloud-d-v3.bc8d743c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cloud-d-v3.svg
// module id = 100
// module chunks = 0